import { Power0, TweenMax } from 'gsap';
import { createOutlineText } from '../../../../Utils/Utils';
import { ProgressBar } from '../../../Shared/ProgressBar';

export class CollectablesProgressBar extends PIXI.Sprite {
    public get progress() {
        return this.progressBar.progress * 100;
    }

    public set progress(value: number) {
        value = value || 0;
        const clampedValue = Math.max(0, Math.min(value, 100));
        this.currentTextProgress = this.progress;
        this.progressBar.progress = clampedValue / 100;
        TweenMax.to(this, this.progressBar.tweenDuration, {
            currentTextProgress: clampedValue,
            onUpdate: () => {
                this.progressText.text = Math.floor(this.currentTextProgress) + '/100';
            },
            ease: Power0.easeNone,
        });
    }

    private progressBar: ProgressBar;
    private progressText: PIXI.Text;
    private currentTextProgress: number;

    constructor(initialProgress: number, width: number, height: number, collectionId?: string) {
        super();
        const progressBar = (this.progressBar = new ProgressBar(initialProgress / 100));
        progressBar.width = width;
        progressBar.height = height;

        const progressText = (this.progressText = createOutlineText(
            initialProgress + '/100',
            new PIXI.Rectangle(0, 0, this.width, this.height),
            'Baloo',
            17,
            27
        ));
        progressText.y += this.height / 2;
        //@ts-ignore
        this.addChild(progressBar, progressText);

        if (collectionId) {
            const iconSprite = new PIXI.Sprite(
                PIXI.utils.TextureCache['mapui/token-' + collectionId + '-icon']
            );
            iconSprite.anchor.set(0.5);
            iconSprite.position.x -= progressBar.width / 2;
            this.addChild(iconSprite);
        }
    }
}
